import Services from 'services';

class PengajuanPettyCashApi {
  get(params) {
    return Services.get('approval_pengajuan_petty_cash/list', { params });
  }

  getHistory(params) {
    return Services.get('approval_pengajuan_petty_cash/history/list', {
      params,
    });
  }

  getSingle(params) {
    return Services.get('approval_pengajuan_petty_cash/detail', {
      params,
    });
  }

  approve(data) {
    return Services.post('approval_pengajuan_petty_cash/approve', data);
  }
}

export default new PengajuanPettyCashApi();
